import { createFileRoute, useParams, useSearch } from '@tanstack/react-router';
import { z } from 'zod';

import { AssignmentResultScreen } from '@/features/assessments/components/shared/AssignmentResultScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute(
  '/_staff/admin/workspace/assessments/assignments/$assignmentId',
)({
  validateSearch: z.object({
    assessmentId: z.string(),
    clientId: z.string().optional(),
  }),
  beforeLoad: () => {
    requirePermission('assessment:read');
  },
  component: Wrap,
  staticData: { crumb: 'Result' },
});

function Wrap() {
  const { assignmentId } = useParams({
    from: '/_staff/admin/workspace/assessments/assignments/$assignmentId',
  });
  const { assessmentId, clientId } = useSearch({
    from: '/_staff/admin/workspace/assessments/assignments/$assignmentId',
  });
  return (
    <AssignmentResultScreen
      assessmentId={assessmentId}
      assignmentId={assignmentId}
      clientId={clientId}
      backTo={{ to: '/admin/workspace/assessments/assignments', label: 'Assignments' }}
    />
  );
}
